"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
if ((typeof cabox === "undefined" ? "undefined" : _typeof(cabox)) != 'object') {
  window.cabox = {
    caevents: [],
    ac: null,
    img: null,
    box: null,
    back: null,
    activeNode: null,
    caleft: null,
    caright: null,
    tstartX: null,
    tstartY: null,
    tX: null,
    tY: null,
    touchStart: null,
    build: function build() {
      var a = this;
      if (!a.box) {
        a.box = document.createElement('div');
        a.box.id = 'caholder';
        a.box.style.display = 'none';
        a.box.innerHTML = '<div id="cabox"><div id="caclose"></div><div id="cacontent"></div></div><div id="catitle"></div>';
        qs('#caclose', a.box).addEventListener('click', function () {
          a.closeBox(a);
        });
        a.box.children[0].addEventListener('touchstart', a.touchstart, {
          passive: true
        });
        a.box.children[0].addEventListener('touchmove', a.touchmove, {
          passive: true
        });
        a.box.children[0].addEventListener('touchend', a.touchend, {
          passive: true
        });
        window.addEventListener('keyup', a.keyPressed);
      }
      if (!a.back) {
        a.back = document.createElement('div');
        a.back.id = 'caback';
        a.back.addEventListener('click', function () {
          a.closeBox(a);
        });
      }
    },
    bodyAttach: function bodyAttach(a) {
      if (!a.box.parentNode) {
        document.body.appendChild(a.box);
        document.body.appendChild(a.back);
      }
    },
    touchstart: function touchstart(e) {
      var a = cabox;
      var touch = e.touch || e.touches[0];
      a.tstartX = touch.pageX;
      a.tstartY = touch.pageY;
      a.touchTime = new Date();
    },
    touchmove: function touchmove(e) {
      var touch = e.touch || e.touches[0];
      var a = cabox;
      a.tX = touch.pageX;
      a.tY = touch.pageY;
    },
    touchend: function touchend(e) {
      var a = cabox;
      if (a.tstartX && a.tX && a.caright && a.caleft) {
        var swipewidth = a.box.children[0].offsetWidth / 5;
        var swipeheight = a.box.children[0].offsetHeight / 10;
        if ((a.tX < a.tstartX - swipewidth || a.tX > a.tstartX + swipewidth) && a.tY > a.tstartY - swipeheight && a.tY < a.tstartY + swipeheight) {
          var currentTime = new Date();
          if (currentTime.getTime() - a.touchTime.getTime() < 500) {
            if (a.tX < a.tstartX - swipewidth) {
              a.caright.click();
            }
            if (a.tX > a.tstartX + swipewidth) {
              a.caleft.click();
            }
            e.stopPropagation();
          }
        }
        a.tstartX = a.tstartY = a.tX = a.tY = false;
      }
    },
    keyPressed: function keyPressed(e) {
      var a = cabox;
      switch (e.keyCode) {
        case 27:
          a.closeBox(a);
          break;
      }
    },
    init: function init(sel, options) {
      var a = this;
      var nodes;
      if (typeof sel == 'string') {
        nodes = qa(sel);
      } else if (sel) {
        nodes = sel;
      }
      if (!a.box || !a.back) {
        a.build();
      }
      if (!options) {
        options = {};
      }
      var content = qs('#cacontent', a.box);
      var title = qs('#catitle', a.box);
      var activeIndex = 0;
      var prevItem = function prevItem(e) {
        var nextIndex = activeIndex == 0 ? nodes.length - 1 : activeIndex - 1;
        if (nextIndex != activeIndex) {
          displayBox(nodes[nextIndex]);
          a.activeNode = nodes[nextIndex];
        }
      };
      var nextItem = function nextItem(e) {
        var nextIndex = activeIndex == nodes.length - 1 ? 0 : activeIndex + 1;
        if (nextIndex != activeIndex) {
          displayBox(nodes[nextIndex]);
          a.activeNode = nodes[nextIndex];
        }
      };
      var positionZoom = function positionZoom(e, imgHolder, img, zoomSection) {
        var imgHolderRect = imgHolder.getBoundingClientRect();
        var x = e.offsetX ? e.offsetX : e.touches[0].clientX - imgHolderRect.x;
        var y = e.offsetY ? e.offsetY : e.touches[0].clientY - imgHolderRect.y;
        var xRatio = x / imgHolder.offsetWidth;
        var yRatio = y / imgHolder.offsetHeight;
        var leftPerc = xRatio * 100;
        var topPerc = yRatio * 100;
        var heightRatio = imgHolder.offsetHeight / img.height;
        var widthRatio = imgHolder.offsetWidth / img.width;
        Object.assign(zoomSection.style, {
          top: topPerc + '%',
          left: leftPerc + '%',
          backgroundPosition: -(img.width * xRatio - zoomSection.offsetWidth / 2) + 'px ' + -(img.height * yRatio - zoomSection.offsetWidth / 2) + 'px'
        });
      };
      var displayBox = function displayBox(n) {
        if (!a.box || !a.back) {
          a.build();
        }
        a.bodyAttach(a);
        if (a.caleft) {
          if (a.box.contains(a.caleft)) {
            a.box.children[0].removeChild(a.caleft);
            a.box.children[0].removeChild(a.caright);
          }
        }
        document.body.style.overflow = 'hidden';
        if (nodes && nodes.length > 1) {
          a.caleft = document.createElement('div');
          a.caleft.id = 'caleft';
          a.box.children[0].insertBefore(a.caleft, a.box.children[0].firstChild);
          a.caright = document.createElement('div');
          a.caright.id = 'caright';
          a.box.children[0].insertBefore(a.caright, a.box.children[0].firstChild);
          a.caleft.addEventListener('click', prevItem);
          a.caright.addEventListener('click', nextItem);
        }
        var wait = false;
        if (n) {
          activeIndex = parseInt(ds(n, 'caindex'));
        }
        var titlecontent = n && n.title ? n.title : options.title ? options.title : '';
        if (titlecontent != '') {
          titlecontent = '<div>' + titlecontent + '</div>';
        }
        if (a.ac) {
          a.ac.abort();
        }
        a.box.className = 'displaying';
        a.back.className = 'active';
        Object.assign(a.box.children[0].style, {
          width: options.width ? options.width : '',
          maxWidth: options.maxwidth ? options.maxwidth : '',
          height: options.height ? options.height : ''
        });
        var htgt;
        if (n && typeof n.href != 'undefined' && n.href.indexOf('#') > -1 && n.href.indexOf(location.href) > -1) {
          var h = n.href.substring(n.href.indexOf('#'), n.href.length);
          htgt = qs(h);
        }
        if (options.content) {
          if (typeof options.content == 'string') {
            content.innerHTML = '<div id="castaticholder">' + options.content + '</div>';
          } else {
            var d = document.createElement('div');
            d.id = 'castaticholder';
            d.appendChild(options.content);
            content.innerHTML = '';
            content.appendChild(d);
          }
          var csh = content.children[0];
          Object.assign(content.children[0].style, {
            width: options.width ? options.width : '',
            maxWidth: options.maxwidth ? options.maxwidth : '',
            height: options.height ? options.height : '',
            minWidth: options.width || options.maxwidth || options.height ? 'auto' : ''
          });
        } else if (options.type == 'iframe' || n && n.classList.contains('iframe')) {
          content.innerHTML = '<div id="caframeholder"><iframe frameborder="0" hspace="0" allow="autoplay" src="' + n.href + '"></iframe></div>';
        } else if (n) {
          wait = true;
          content.innerHTML = '<div class="escholder"><div class="loader"></div></div>';
          if (new RegExp(/\.(jpg|gif|png|bmp|jpeg|webp)(.*)?$/i).test(n.href)) {
            a.img = new Image();
            a.img.addEventListener('load', function () {
              content.innerHTML = '<div id="caimageholder"><img src="' + n.href + '" alt="' + n.title + '" draggable="false" /><div class="zoomSection" style="background-image:url(\'' + n.href + '\'); background-size:' + a.img.width + 'px ' + a.img.height + 'px"></div></div>';
              a.box.className = '';
              setTimeout(function () {
                a.box.className = 'displayed';
                var imgHolder = qs('#caimageholder', content);
                if (a.img.height > window.innerHeight * .9 || a.img.width > window.innerWidth * .9) {
                  imgHolder.classList.add('zoomable');
                  var zoomSection = qs('.zoomSection', imgHolder);
                  var zoomDrag = false;
                  var startTime;
                  var zoomStart = function zoomStart(e) {
                    positionZoom(e, imgHolder, a.img, zoomSection);
                    zoomDrag = true;
                    imgHolder.classList.add('over');
                    startTime = new Date();
                  };
                  var zoomMover = function zoomMover(e) {
                    if (zoomDrag) {
                      positionZoom(e, imgHolder, a.img, zoomSection);
                    }
                  };
                  var zoomEnd = function zoomEnd() {
                    zoomDrag = false;
                    imgHolder.classList.remove('over');
                  };
                  imgHolder.addEventListener('touchstart', zoomStart, {
                    passive: true
                  });
                  imgHolder.addEventListener('mousedown', zoomStart, {
                    passive: true
                  });
                  imgHolder.addEventListener('mousemove', zoomMover, {
                    passive: true
                  });
                  imgHolder.addEventListener('touchmove', zoomMover, {
                    passive: true
                  });
                  imgHolder.addEventListener('mouseup', zoomEnd, {
                    passive: true
                  });
                  imgHolder.addEventListener('touchend', function () {
                    var endTime = new Date();
                    if (startTime && endTime.getTime() - startTime.getTime() < 300) {
                      zoomEnd();
                    }
                  }, {
                    passive: true
                  });
                }
                if (options.onComplete) {
                  options.onComplete();
                }
              }, 50);
            });
            a.img.addEventListener('error', function () {
              content.innerHTML = '<div class="error">An error occurred</div>';
            });
            a.img.src = n.href;
          } else if (htgt) {
            var c = htgt.cloneNode(true);
            c.classList.remove('jspopup');
            var _d = document.createElement('div');
            _d.id = 'castaticholder';
            _d.appendChild(c);
            content.innerHTML = '';
            content.appendChild(_d);
            wait = false;
          } else {
            a.ac = new AbortController();
            fetch(n.href, {
              signal: a.ac.signal
            }).then(function (res) {
              return res.text();
            }).then(function (newtext) {
              if (n.href.indexOf('#') > -1) {
                var nd = document.createElement('div');
                nd.innerHTML = newtext;
                var tgt = n.href.substring(n.href.indexOf('#'), n.href.length);
                var _c = qs(tgt, nd);
                if (_c) {
                  content.innerHTML = _c.innerHTML;
                } else {
                  content.innerHTML = newtext;
                }
              } else {
                content.innerHTML = newtext;
              }
              var scriptcount = 0;
              var loadedcount = 0;
              var inlines = [];
              var executeInlines = function executeInlines() {
                fe(inlines, function (i) {
                  if (i.old.parentNode) i.old.parentNode.replaceChild(i["new"], i.old);
                });
              };
              var scripts = qa('script', content);
              var loadScript = function loadScript(s) {
                var newscript = document.createElement('script');
                fe(s.attributes, function (sa) {
                  newscript.setAttribute(sa.name, sa.value);
                });
                newscript.appendChild(document.createTextNode(s.innerHTML));
                if (s.src) {
                  scriptcount++;
                  newscript.addEventListener('load', function () {
                    loadedcount++;
                    if (loadedcount == scriptcount) {
                      executeInlines();
                    }
                    nextScript();
                  });
                  s.parentNode.replaceChild(newscript, s);
                } else {
                  scriptcount++;
                  loadedcount++;
                  inlines.push({
                    old: s,
                    "new": newscript
                  });
                  nextScript();
                }
              };
              var scriptqueueid = -1;
              var nextScript = function nextScript() {
                scriptqueueid++;
                if (scriptqueueid < scripts.length) {
                  loadScript(scripts[scriptqueueid]);
                } else {
                  executeInlines();
                }
              };
              nextScript();
              a.box.className = 'displayed';
              if (options.onComplete) {
                options.onComplete();
              }
              if (scriptcount == 0) {
                executeInlines();
              }
            })["catch"](function () {
              content.innerHTML = '<div class="error">An error occurred</div>';
            });
          }
        }
        a.box.style.display = 'block';
        title.innerHTML = titlecontent;
        if (!wait) {
          a.box.className = '';
          setTimeout(function () {
            a.box.className = 'displayed';
            if (options.onComplete) {
              options.onComplete();
            }
          }, 50);
        }
      };
      var loadThis = function loadThis(e) {
        if (!e.target.closest('.dragging')) {
          displayBox(this);
          a.activeNode = this;
          e.preventDefault();
        }
      };
      if (!sel) {
        displayBox();
      }
      if (nodes) {
        fe(nodes, function (n, i) {
          ds(n, 'caindex', i);
          a.caevents.forEach(function (m, j) {
            if (n.innerHTML == m.node.innerHTML) {
              removeEventListener('click', m.listener);
              a.caevents.splice(j, 1);
            }
          });
          var evt = {
            node: n,
            listener: loadThis
          };
          if (options.onClose) {
            evt.onClose = options.onClose;
          }
          a.caevents.push(evt);
          n.addEventListener('click', loadThis);
        });
      }
    },
    showLoader: function showLoader() {
      var a = this;
      if (!a.box || !a.back) {
        a.build();
      }
      a.bodyAttach(a);
      var content = document.getElementById('cacontent');
      content.innerHTML = '<div class="escholder"><div class="loader"></div></div>';
      a.box.className = 'displaying';
      a.box.style.display = 'block';
      a.back.className = 'active';
      setTimeout(function () {
        a.box.className = 'displayed';
      }, 50);
    },
    closeBox: function closeBox(box) {
      var a = box || this;
      if (a.box) {
        a.box.className = 'hiding';
        a.back.className = 'hiding';
        if (a.ac) {
          a.ac.abort();
        }
        if (a.img) {
          a.img.onload = function () {};
        }
        setTimeout(function () {
          a.box.className = '';
          a.back.className = '';
          a.box.style.display = '';
          document.body.style.overflow = '';
          var content = qs('#cacontent', a.box);
          content.innerHTML = '';
        }, 500);
        a.caevents.forEach(function (m, j) {
          if (a.activeNode && a.activeNode.innerHTML == m.node.innerHTML && m.onClose) {
            m.onClose();
          }
        });
        if (typeof e != 'undefined') {
          e.preventDefault();
        }
      }
    }
  };
}